import { getDay, parseISO } from 'date-fns';
import { DateFormats } from '../enums';
import { formatDateToString } from './date-to-string.util';

/**
 * Parsuje datę kalendarzową "YYYY-MM-DD" (datę „pływającą", bez strefy) do **lokalnej północy**.
 * Używaj dla `scheduledFor`, dni paska aktywności, etykiet dni itp. - `new Date("YYYY-MM-DD")`
 * dałoby północ UTC i przesunęło dzień w strefach z ujemnym offsetem (USA).
 */
export const parseWallDate = (wallDate: string): Date => parseISO(wallDate);

/** Dzisiejsza data kalendarzowa użytkownika jako "YYYY-MM-DD" (strefa lokalna urządzenia). */
export const todayWallDate = (): string => formatDateToString(new Date(), DateFormats.IsoDate);

/** Dzień tygodnia daty kalendarzowej (0=niedziela), stabilny strefowo. */
export const wallWeekday = (wallDate: string): number => getDay(parseWallDate(wallDate));
